import React, { useContext } from 'react'
import { AppContext } from '../../../App'
import axios from 'axios'
import config from '../../../config.json'

export default function ResinousSystemType(props) {
   const {
      features:featuresDirty,
      numberOfCoats,
      overallThickness,
      name,
      subheading,
      shortDescription
   } = props

   const {
      setCurrentStep,
      productTypeSteps,
      setAppHeader,
      setLinkGoBackTarget,
      productOptionsSelected,
      setProductOptionsSelected,
      stepsCompleted,
      setStepsCompleted,
      setAvailableSmallColors,
      setAvailableLargeColors,
       setAvailableSmallChipColors,
       setAvailableLargeChipColors,
       setAvailableSmallQuartzColors,
       setAvailableLargeQuartzColors,
    setAvailableSmallVaporBanColors,
       setAvailableLargeVaporBanColors,
       setAvailableSmallVaporBanChipColors,
       setAvailableLargeVaporBanChipColors,
       setAvailableSmallMvbColors,
       setAvailableLargeMvbColors,
       setAvailableSmallMvbChipColors,
       setAvailableLargeMvbChipColors,
   } = useContext(AppContext)

   // Clean a given array's strings for a specific character, replaced with a specified replacement character.
   function cleanArrayStringsOfChar(array, char, replacement) {
      const cleanArray = array.map(item => {
         return item.replace(char, replacement)
      })
      return cleanArray
   }

   // Convert incoming "features" HTML-laden string to an array, by first replacing each tag with a comma, then splitting into array at each comma, then removing all null array values.
   const featuresCleaned = featuresDirty.replace(/(<([^>]+)>)/gi, 'XYZYX')
   const featuresSplit = featuresCleaned.split('XYZYX')
   const featuresArray = featuresSplit.map(feature => {
      return feature
   }).filter(Boolean)

   // Clean featuresArray items for special characters that are coded as web-safe characters.
   const featuresArrayCleaned1 = cleanArrayStringsOfChar(featuresArray, '&amp;', '&')
   const featuresArrayCleaned2 = cleanArrayStringsOfChar(featuresArrayCleaned1, '&ndash;', '—')
   const featuresArrayCleaned3 = cleanArrayStringsOfChar(featuresArrayCleaned2, '&mdash;', '—')
   const featuresArrayCleaned4 = cleanArrayStringsOfChar(featuresArrayCleaned3, '&nbsp;', ' ')

   // Filter featuresArray to remove any entry that has a character length < 6, which denotes garbage non-data leftover from previous string cleaning.
   const features = featuresArrayCleaned4.filter(feature => feature.length > 5)

    const resinousApplication = productOptionsSelected.productOptions[2]
    
   const systemName = productOptionsSelected.productOptions[3].toLowerCase()

   const handleResinousSystemTypeSelected = () => {
      // Update the current step.
      // // - If Cove was selected, next step is Cove-specific form.
      // resinousApplication==="Cove" ? (
      //     setCurrentStep({ step: "resinousCoveCoverageDetails" })
      // ) : (
      // - Else next step is standard resinous form (Floor and Wall).
      setCurrentStep({ step: "resinousCoverageDetails" })
      // )

      // Set the Go Back link
      setLinkGoBackTarget({ link: "resinousSystemTypeSelection" })
      // Set the appHeader for Step state
      setAppHeader("Step 4 of " + (productTypeSteps))
      // Add the selected resinous application to state of App
      productOptionsSelected.productOptions.push(name)
      
      setProductOptionsSelected({ productOptions: productOptionsSelected.productOptions })
      // Update the steps completed to include this step.
      stepsCompleted.push("Select "+resinousApplication+" System Type")
      setStepsCompleted(stepsCompleted)
      
       const nameLowerCase = name.toLowerCase()

       setAvailableSmallColors([])
       setAvailableLargeColors([])
       setAvailableSmallChipColors([])
       setAvailableLargeChipColors([])
       setAvailableSmallQuartzColors([])
       setAvailableLargeQuartzColors([])
       setAvailableSmallVaporBanColors([])
       setAvailableLargeVaporBanColors([])
       setAvailableSmallVaporBanChipColors([])
       setAvailableLargeVaporBanChipColors([])
       setAvailableSmallMvbColors([])
       setAvailableLargeMvbColors([])
       setAvailableSmallMvbChipColors([])
       setAvailableLargeMvbChipColors([])

      // Retrieve available system colors and chips from API.
       let apiUrlNoVaporBarrierColors = config.resinousMainCalculationEndpoint + "/sqft/" + name.toLowerCase() + '/' + resinousApplication.toLowerCase() + '/no/no/no/no/1/en'
       
       let apiUrlVaporBanColors = config.resinousMainCalculationEndpoint + "/sqft/" + name.toLowerCase() + '/' + resinousApplication.toLowerCase() + '/yes/no/no/no/1/en'
       let apiUrlMvbColors = config.resinousMainCalculationEndpoint + "/sqft/" + name.toLowerCase() + '/' + resinousApplication.toLowerCase() + '/no/yes/no/no/1/en'

       axios.get(apiUrlNoVaporBarrierColors)
          .then(res => {
         // Sort through response and find which product is for chips or quartz (same colors for both), grab the colors provided.
         res.data.map(r => {
             return (
                 r.colors && (
                     // If it's chip or quartz
                     r.theseAreChipColors == "true" ? (
                         r.unitSize.toLowerCase() == "small units" ? (
                             setAvailableSmallChipColors(JSON.parse(r.colors))
                         ) : setAvailableLargeChipColors(JSON.parse(r.colors))
                     ) : r.theseAreQuartzColors == "true" ? (
                         r.unitSize.toLowerCase() == "small units" ? (
                             setAvailableSmallQuartzColors(JSON.parse(r.colors))
                         ) : setAvailableLargeQuartzColors(JSON.parse(r.colors))
                     ) :
                            r.unitSize.toLowerCase() == "small units" ? (
                                    setAvailableSmallColors(JSON.parse(r.colors))
                                ) : setAvailableLargeColors(JSON.parse(r.colors))
                                )
            )
         })
          })

       axios.get(apiUrlMvbColors)
           .then(res => {
               // Sort through response and find which product is for vapor ban or MVB (same colors for both). This replaces chip and polyaspartic if selected
               res.data.map(r => {
                   return (
                       r.colors && r.isPigmentKit == "false" && r.addOnMvb == "yes" && (
                           // If it's chip or quartz
                           r.theseAreChipColors == "true" || r.theseAreQuartzColors == "true" ? (
                               r.unitSize.toLowerCase() == "small units" ? (
                                   setAvailableSmallMvbChipColors(JSON.parse(r.colors))
                               ) :
                                   setAvailableLargeMvbChipColors(JSON.parse(r.colors))
                           ) :
                               r.unitSize.toLowerCase() == "small units" && r.unitForDisplayOnly.toLowerCase() == "small" ? (
                                   setAvailableSmallMvbColors(JSON.parse(r.colors))
                               ) :
                                   (r.unitSize.toLowerCase() == "large units" && r.unitForDisplayOnly.toLowerCase() == "large" ? setAvailableLargeMvbColors(JSON.parse(r.colors))
                                       : setAvailableSmallMvbColors(JSON.parse(r.colors)))
                       )
                       )
               })
           })

       axios.get(apiUrlVaporBanColors)
           .then(res => {
               // Sort through response and find which product is for vapor ban or MVB (same colors for both). This replaces chip and polyaspartic if selected
               res.data.map(r => {
                   return (
                       r.colors && r.isPigmentKit == "false" && r.addOnVaporBanER == "yes" && (
                           // If it's chip or quartz
                           r.theseAreChipColors == "true" || r.theseAreQuartzColors == "true" ? (
                               r.unitSize.toLowerCase() == "small units" ? (
                                   setAvailableSmallVaporBanChipColors(JSON.parse(r.colors))
                               ) : setAvailableLargeVaporBanChipColors(JSON.parse(r.colors))
                           ) :
                               r.unitSize.toLowerCase() == "small units" ? (
                                   setAvailableSmallVaporBanColors(JSON.parse(r.colors))
                               ) : setAvailableLargeVaporBanColors(JSON.parse(r.colors))
                       )
                   )
               })
           })
   }
   
   return (    
      <div className="list-item" key={ name + " : " + subheading }>
         <div className="row p-1">
            <div className="col-xs-12 col-sm-8 col-lg-9">
               <h4>{ name } { subheading && <small>{ subheading }</small> }</h4>
            </div>
            <div className="col-xs-4 col-sm-4 col-lg-3 hidden-xs">
               <button className="btn btn-primary btn-block" onClick={() => handleResinousSystemTypeSelected({ name })}>SELECT</button>
            </div>
         </div>
         <div className="row p-1">
            <div className="col-xs-12">
               <p>{ shortDescription }</p>
            </div>
         </div>
         <div className="row p-1">
            <div className="col-xs-12">
               <p><strong>Features</strong></p>
               <ul>
               {
                  features.map((feature, index) => {
                        return <li key={ "feature_" + index }>{ feature }</li>
                  })
               }
               </ul>
            </div>
            <div className="col-xs-12">
               <p><strong>Specifications</strong></p>
               <ul>
                  <li>Number of coats: { numberOfCoats }</li>
                  <li>Overall thickness: { overallThickness }</li>
               </ul>
            </div>
         </div>
         <div className="row visible-xs">
            <div className="col-xs-12">
               <button className="btn btn-primary btn-block" onClick={() => handleResinousSystemTypeSelected({ name })}>SELECT</button>
            </div>
         </div>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousSystemType.js